<template>
	<div class=" sidebar">
		<div class="menu">
			<router-link tag="a" to="/account/tickets" :class="{ selected: selectedTab == 'tickets' }">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="icon icon-tabler icon-tabler-ticket"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
					<line x1="15" y1="5" x2="15" y2="7"></line>
					<line x1="15" y1="11" x2="15" y2="13"></line>
					<line x1="15" y1="17" x2="15" y2="19"></line>
					<path
						d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"
					></path>
				</svg>
				Mis tickets
			</router-link>
			<router-link tag="a" to="/account/memberships" :class="{ selected: selectedTab == 'memberships' }">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="icon icon-tabler icon-tabler-star"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
					<path
						d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
					></path>
				</svg>
				Mis membresías
			</router-link>

			<hr />

			<template v-if="$store.getters.loggedUser.isPromotor">
				<router-link tag="a" to="/account/events" :class="{ selected: selectedTab == 'events' }">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="icon icon-tabler icon-tabler-speakerphone"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						stroke-width="2"
						stroke="currentColor"
						fill="none"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
						<path d="M18 8a3 3 0 0 1 0 6"></path>
						<path d="M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"></path>
						<path
							d="M12 8h0l4.524 -3.77a0.9 .9 0 0 1 1.476 .692v12.156a0.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8"
						></path>
					</svg>
					Mis eventos
				</router-link>

				<hr />
			</template>

			<router-link tag="a" to="/account/personal-data" :class="{ selected: selectedTab == 'personal-data' }">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="icon icon-tabler icon-tabler-user-circle"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
					<circle cx="12" cy="12" r="9"></circle>
					<circle cx="12" cy="10" r="3"></circle>
					<path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"></path>
				</svg>
				Datos personales
			</router-link>
			<router-link tag="a" to="/account/security" :class="{ selected: selectedTab == 'security' }">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="icon icon-tabler icon-tabler-shield-lock"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
					<path
						d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
					></path>
					<circle cx="12" cy="11" r="1"></circle>
					<line x1="12" y1="12" x2="12" y2="14.5"></line>
				</svg>
				Inicio de sesión y seguridad
			</router-link>

			<hr />
			<router-link tag="a" to="/logout">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="icon icon-tabler icon-tabler-logout"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					stroke-width="2"
					stroke="currentColor"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
					<path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"></path>
					<path d="M7 12h14l-3 -3m0 6l3 -3"></path>
				</svg>
				Salir
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: "AccountSidebar",
	props: {
		tab: {
			type: String
		}
	},
	async beforeMount() {
		if (this.$route.params.tab) this.selectedTab = this.$route.params.tab
		if (this.tab) this.selectedTab = this.tab
	},
	data() {
		return {
			selectedTab: "tickets"
		}
	}
}
</script>

<style scoped lang="scss">
.sidebar {
	width: 220px;
	padding: 0;
	flex-grow: 0;
	flex-shrink: 0;
}

.menu {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	a {
		width: 100%;
		display: flex;
		padding: 8px;
		align-items: center;
		font-size: 0.9rem;
		font-weight: 400;
		border-radius: 6px;
		svg {
			margin-right: 6px;
		}
		&.selected {
			font-weight: 500;
			color: #476a9f;
			background-color: #476a9f20;
		}
	}
}
</style>
